import { Actor, Collider, CollisionContact, Color, Engine, Rectangle, Side, vec } from 'excalibur';

type Damageable = { damage: (amount: number) => void };

function hasDamageFn(obj: unknown): obj is Damageable {
    return !!obj && typeof (obj as any).damage === 'function';
}

export class Missile extends Actor {
    private _vx = 0;
    private _vy = 0;

    /** configure as needed (or pass into ctor) */
    private readonly _damageAmount = 10;

    constructor(x: number, y: number, angle: number, speed: number) {
        super({
            pos: vec(x, y),
            width: 10,
            height: 4,
            anchor: vec(0.5, 0.5),
            rotation: angle,
        });

        this._vx = Math.cos(angle) * speed;
        this._vy = Math.sin(angle) * speed;

        this.graphics.use(
            new Rectangle({
                width: 10,
                height: 4,
                color: Color.Yellow,
            }),
        );
    }

    override onPreUpdate(engine: Engine, delta: number): void {
        const dt = delta / 1000;
        this.pos.x += this._vx * dt;
        this.pos.y += this._vy * dt;
    }

    override onCollisionStart(
        self: Collider,
        other: Collider,
        side: Side,
        contact: CollisionContact,
    ): void {
        const otherOwner = other.owner;

        // Ignore collisions with non-actors or with self (paranoia)
        if (!otherOwner || otherOwner === this) return;

        if (hasDamageFn(otherOwner)) {
            otherOwner.damage(this._damageAmount);
        }

        // Typical missile behavior: remove on first impact
        this.kill();
    }
}
